export default "__VITE_ASSET__ea045a5e__"